export default __webpack_public_path__ + "static/video1-9edff269081ee9b1cd385de3f4b266ea.webp";